<template>
	<el-container>
		<el-header style="padding: 0px; height: 64px">
			<Logo></Logo>
			<!-- <div class="toggle">
				<span @click="toggleCollapse">
					<i class="el-icon-s-fold" v-if="!$store.getters['menu/collapse']"></i>
					<i class="el-icon-s-unfold" v-if="$store.getters['menu/collapse']"></i>
				</span>
			</div> -->
			<div class="topNav">
				<el-menu router :default-active="menuIndex1" mode="horizontal" background-color="#717D99"
					text-color="#ffffff" active-text-color="white">
					<template v-for="first in list">
						<el-menu-item :index="first.route" :key="first.route"
							:class="first.route == choosedMenu ? 'is-active' : ''">
							<i :class="first.icon" class="fs14"></i>
							{{ first.title }}
						</el-menu-item>

						<!--      <el-submenu
              v-else
              :index="first.route"
              class="oh"
              style="height: 60px"
            >
              <template slot="title">
                <i :class="first.icon" class="fs14"></i>
                {{ first.title }}</template
              >
              <el-menu-item
                v-for="second in first.sub"
                :index="second.route"
                :key="second.route"
                :class="
                  second.route === activeIndex ? 'is-active' : 'no-active'
                "
              >
                {{ second.title }}
              </el-menu-item>
            </el-submenu> -->
					</template>
				</el-menu>
			</div>
			<Navbar></Navbar>
		</el-header>

		<el-container>
			<el-aside :width="$store.getters['menu/collapse'] ? '60px' : '70px'"
				v-if="list.length > 0 && index1 > -1 && list[index1].sub.length >= 1">
				<el-menu height:100vh :collapse="$store.getters['menu/collapse']" router :default-active="menuIndex2"
					class="el-menu-box" :unique-opened="true" :collapse-transition="false" background-color="#717D99"
					text-color="#ffffff" active-text-color="white">
					<template v-for="second in list[index1].sub">
						<template v-if="second.sub.length >= 1">
							<el-submenu :key="second.route" :index="second.route">
								<template slot="title">
									<p class="h30 lh40"><i :class="second.icon" class="fs18 pl6" ></i></p>
									<p class="h30 lh30"><span slot="title" class="fs14">{{ second.title }}</span></p>
								</template>
								<el-menu-item-group>
									<el-menu-item v-for="(third, k2) in second.sub" :key="k2" :index="third.route"
										style="padding-left: 10px !important;">
										{{ third.title }}
									</el-menu-item>
								</el-menu-item-group>
							</el-submenu>
						</template>
						<template v-else>
							<el-menu-item :index="second.route" :key="second.route">
								<p class="h30 lh40"><i :class="second.icon" class="fs18 pl6" style="color: #ffffff;"></i></p>
								<p class="h30 lh30 "><span slot="title" class="fs14">{{ second.title }}</span></p>
							</el-menu-item>
						</template>
					</template>
				</el-menu>
			</el-aside>


			<el-container direction="vertical" style="width: 100%">
				<el-footer style="height: 40px" v-if="$store.state.menu.showLast">
					<el-tabs @tab-click="tabClick" v-model="menuIndex3">
						<el-tab-pane v-for="last in list[index1].sub[index2].sub[index3].sub" :key="last.title"
							:label="last.title" :name="last.route">
						</el-tab-pane>
					</el-tabs>
				</el-footer>
				<el-main :style="`height:calc(100vh - ${
            $store.state.menu.showLast ? 100 : 60
          }px);overflow-y:auto;`">
					<section class="mainBg">
						<router-view></router-view>
					</section>
				</el-main>
			</el-container>
		</el-container>
	</el-container>
</template>

<script>
	import Logo from "./logo";
	import Navbar from "./navbar";
	export default {
		name: "Layout",
		methods: {
			toggleCollapse() {
				this.$store.commit("menu/SetCollapse", !this.$store.state.menu.collapse);
			},
			tabClick(e) {
				this.$router.push(
					this.list[this.index1].sub[this.index2].sub[this.index3].sub[e.index]
					.path
				);
			},
		},
		components: {
			Logo: Logo,
			Navbar: Navbar,
		},
		computed: {
			// 这里用来判断进入二级菜单后，保持菜单的选中状态
			choosedMenu() {
				// 将路径切开
				let menuCut = this.$route.path.split("/");
				let menuLength = menuCut.length;
				// 判断是不是二级菜单，如果是，就和一级菜单匹配
				if (menuLength > 2) {
					return `/${menuCut[1]}`;
				}
				return "";
			},

			activeIndex() {
				return this.$route.path;
			},
			list() {
				return this.$store.getters.menuList;
			},
			menuIndex1() {
				return this.$store.state.menu.menuIndex1;
			},
			menuIndex2() {
				return this.$store.state.menu.menuIndex2;
			},
			menuIndex3: {
				get() {
					return this.$store.state.menu.menuIndex3;
				},
				set(menuIndex3) {
					this.$store.commit("menu/SetIndex", {
						menuIndex3
					});
				},
			},
			index1() {
				return this.$store.state.menu.index1;
			},
			index2() {
				return this.$store.state.menu.index2;
			},
			index3() {
				return this.$store.state.menu.index3;
			},
			index4() {
				return this.$store.state.menu.index4;
			},
		},
		created() {
			this.$store.dispatch("menu/GetMenu");
		},
	};
</script>

<style lang="scss" scoped>
	.el-header {
		background-color: #717D99;
		color: #ffffff;
		text-align: center;
		height: 64px;

		i {
			font-size: 20px;
			color: #ffffff;
			position: relative;
			top: -1px;
		}

		.el-menu-item {
			border-bottom-color: none !important;
		}

		.el-menu-item.is-active {
			background-color: #8590A8 !important;
			border-top: 4px solid #8590A8 !important;
			line-height: 55px !important;
			color: #ffffff !important;

			i {
				color: #ffffff !important;
			}
		}
	}

	.is-active {
		background-color: #A9B2C5 !important;
		border-bottom-color: #A9B2C5 !important;
		color: #ffffff !important;

		i {
			color: white !important;
		}
	}

	.no-active {
		background-color: #2f314f !important;
		color: #ffffff !important;
		border-top: 4px #2f314f !important;
	}

	.el-aside {
		background-color: #2f314f;
		color: #ffffff;
		text-align: center;
		height: calc(100vh - 64px);
		overflow: hidden;

		.el-menu-box {
			width: calc(100% + 12px);
			text-align: left;
			border-right: solid 0px #e6e6e6;
			height: calc(100vh - 64px);
			overflow-y: auto;
			overflow-x: hidden;

			.el-menu-item.is-active {
				background-color: #A9B2C5 !important;
				border-bottom-color: none !important;
			}
		}
	}

	.topNav {
		// width: calc(100% - 300px);
		float: left;
		margin-left: 15px;
	}

	.el-menu-item-group {
		background-color: #ff8f48;

		.el-menu-item {
			background-color: #42425a !important;
		}

		.el-menu-item:hover {
			background-color: #42425a !important;
		}
	}

	.el-submenu .el-menu-item {
		min-width: 130px;
	}

	.toggle {
		float: left;
		height: 60px;
		width: 70px;
		padding-top: 21px;
		padding-left: 15px;
		text-align: left;

		i {
			font-size: 18px;
		}

		i:hover {
			cursor: pointer;
			color: white;
		}
	}
</style>
<style lang="scss">
	.el-aside {
		.el-submenu {
			.el-submenu__icon-arrow {
				top: calc(50% + 4px) !important;
			}
		}

		.el-menu--collapse {
			width: 100% !important;
		}
	}

	.topNav {

		.el-menu,
		.el-menu.el-menu--horizontal {
			border-bottom: none;
		}
	}

	.el-main {
		background-color: #f0f0f4;
		padding: 10px !important;
		height: calc(100vh - 64px) !important;

		.mainBg {
			border-radius: 5px;
		}
	}

	.el-menu .el-menu-item {
		height: 64px !important;
		line-height: 64px !important;
	}


	.el-submenu__title {
		border-bottom: none !important;
		line-height: 66px !important;
	}

	.is-active .el-submenu__title {
		line-height: 58px !important;

		i {
			color: #ffffff;
		}
	}
</style>
